// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export default styled.div`
  .product-detail-container {
    position: relative;
    width: 96%;
    height: 93%;
    display: flex;
    flex-grow: 0;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    border: solid 1px ${(props) => props.theme.colorPalette.gray[500]};
    background-color: ${(props) => props.theme.colorPalette.white};
    box-sizing: border-box;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    margin-left: 0px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};

    .product-online-exclusive-tag {
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
      font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
      color: ${(props) => props.theme.colorPalette.gray[900]};
      text-align: left;
      letter-spacing: 0.42px;
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    }
    .product-description {
      margin-left: 5px;
      margin-right: 0;
      width: calc(100% - 12px);
    }
    .product-details {
      margin-left: 5px;
      margin-right: 0;
      float: left;
      width: 100%;
      margin-bottom: 5px;
    }
  }
  .brand-image {
    width: 53px;
    height: 20px;
  }

  .product-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    .product-image {
      width: 68px;
      height: 81px;
      object-fit: cover;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        width: 65px;
      }
    }
  }
  .content-separator {
    margin: 0 8px;
  }

  .atb-product-detail-section {
    width: 69%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 60%;
    }
  }
  .added-to-bag-points-portal {
    display: inline;
    div {
      display: inline;
    }
    .text-value {
      display: inline;
    }
  }
  .double-points {
    display: inline;
  }

  .promotion-label-container {
    position: ${(props) => (props.isCarouselIncluded ? 'relative' : 'absolute')};
    width: ${(props) => (props.isCarouselIncluded ? '100%' : '')};
    right: ${(props) =>
      props.isCarouselIncluded
        ? props.theme.spacing.ELEM_SPACING.XXS
        : props.theme.spacing.ELEM_SPACING.XS_1};
    bottom: ${(props) => (props.isCarouselIncluded ? 0 : props.theme.spacing.ELEM_SPACING.XS_1)};
  }
  .style-with-accessories {
    height: auto;

    & .product-detail-container {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0 0
        ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }

  .saveSize-check {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }

  .saveSize-check .CheckBox__input {
    ${(props) =>
      !props.isUserPersonalizationEnabled &&
      `height: 16px;
      width: 16px;
    &:before {
      border: 1px solid #1a1a1a;
      border-radius: 4px;
    }
    &:after {
    left: 6px;
    top: 1px;
    }`}
  }
  .product-info-compact-design {
    width: 96%;
    height: 94px;
    display: flex;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 14px;
    border: solid 1px ${(props) => props.theme.colorPalette.gray[500]};
    background-color: ${(props) => props.theme.colorPalette.white};
    box-sizing: border-box;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    margin-left: 0px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    align-items: center;
    justify-content: space-between;
  }
  .product-info-compact-design-with-accessory {
    width: 96%;
    height: 94px;
    display: flex;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 14px;
    border: solid 1px ${(props) => props.theme.colorPalette.gray[500]};
    background-color: ${(props) => props.theme.colorPalette.white};
    box-sizing: border-box;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    margin-left: 0px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    align-items: center;
    justify-content: space-between;
  }
  .image-component {
    width: 55px;
    height: 70px;
    img {
      width: 55px;
      height: 70px;
    }
  }
  .image-component-container {
    display: flex;
  }
  .amount-component {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    color: ${(props) => props.theme.colorPalette.red[500]};
  }
  .divider-component {
    border: solid 0.5px ${(props) => props.theme.colorPalette.gray[500]};
    height: 68px;
    margin: 0px 8px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0px 14px;
    }
  }
  .left-component {
    display: flex;
    align-items: center;
  }
  .image-component-accessory {
    padding-left: 6px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-left: 10px;
    }
  }
`;
